import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Error404 = () => {
  const navigate = useNavigate();

  const handleBackHome = () => {
    navigate("/");
  };

  return (
    <div className="error-wrapper">
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col md={8} lg={6}>
            <div className="error-card text-center justify-content-center">
              <h2 className="error-title">404</h2>
              <h4 className="error-subtitle">Page Not Found</h4>
              <p className="error-text">
                Sorry, the page you're trying to access doesn't exist.
              </p>
              <div className="justify-content-center d-flex">
                <Button
                  variant="primary"
                  size="lg"
                  className="custom-home-btn mt-2 d-flex align-items-center"
                  onClick={handleBackHome}
                >
                  <i className="lni lni-arrow-left me-2"></i> Go Back Home
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Error404;
